module.exports = __webpack_public_path__ + "img/8.a3561c02.png";